import { Alert } from '@chronosphereio/chrono-ui';

export interface ErrorAlertProps {
  error: Error;
}

/**
 * Shows an MUI Alert with the `Error.message` as its contents.
 */
export function ErrorAlert(props: ErrorAlertProps) {
  const { error } = props;
  return <Alert severity="error">{error.message}</Alert>;
}
